
export enum TipoJustica {
  AMBAS = <any> 'AMBAS',
  ESPECIAL = <any> 'ESPECIAL',
  COMUM = <any> 'COMUM',
  INDEFINIDO = <any> 'INDEFINIDO',
}
